module.exports = __webpack_public_path__ + "img/degustazione-vini.91c5400c.jpg";